import { EDocumentCategory } from 'FeatureModules/Document/types/document.types';
import { TSiteType } from 'FeatureModules/Site/types/site.types';

export enum EFilterType {
  OWNERSHIP = 'OWNERSHIP',
  SITE_TYPE = 'SITE_TYPE',
  SITES = 'SITES',
  PARTNERS = 'PARTNERS',
  RAW_MATERIALS = 'RAW_MATERIALS',
  TIME_FRAME = 'TIME_FRAME',
  DOCUMENT_CATEGORY = 'DOCUMENT_CATEGORY',
  COUNTRIES = 'COUNTRIES',
}

export type TFilterType = `${EFilterType}`;

export enum EEntityOwnership {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  UNASSIGNED = 'UNASSIGNED',
  PARTNER = 'PARTNER',
}

export type TEntityOwnership = `${EEntityOwnership}`;

export type TOwnershipFilterValue = {
  option?: TEntityOwnership | null;
  /**
   * Will be provided if the filter value is partner
   */
  ownedById?: string | null;
} | null;

export type TSiteTypeFilterValue = TSiteType | TSiteType[] | null;
export type ISitesFilterValue = string[] | null;
export type TPartnersFilterValue = string | string[] | null;
export type TRawMaterialsFilterValue = string | string[] | null;
export type TTimeFrameFilterValue = {
  startDate?: Date;
  endDate?: Date;
} | null;
export type TDocumentCategoryFilterValue = EDocumentCategory[] | null;
export type TCountriesFilterValue = string[] | null;

export type TFilterValueType<Type extends TFilterType> = Type extends EFilterType.OWNERSHIP
  ? TOwnershipFilterValue
  : Type extends EFilterType.SITE_TYPE
  ? TSiteTypeFilterValue
  : Type extends EFilterType.SITES
  ? ISitesFilterValue
  : Type extends EFilterType.PARTNERS
  ? TPartnersFilterValue
  : Type extends EFilterType.RAW_MATERIALS
  ? TRawMaterialsFilterValue
  : Type extends EFilterType.TIME_FRAME
  ? TTimeFrameFilterValue
  : Type extends EFilterType.DOCUMENT_CATEGORY
  ? TDocumentCategoryFilterValue
  : Type extends EFilterType.COUNTRIES
  ? TCountriesFilterValue
  : never;

export type TFilter<Type extends EFilterType = EFilterType> = {
  type: Type;
  label?: string;
  multiple?: boolean;
  value?: TFilterValueType<Type>;
};

export type TFilterEvent =
  | {
      type: EFilterType.OWNERSHIP;
      value?: TFilterValueType<EFilterType.OWNERSHIP>;
    }
  | {
      type: EFilterType.SITE_TYPE;
      value?: TFilterValueType<EFilterType.SITE_TYPE>;
    }
  | {
      type: EFilterType.SITES;
      value?: TFilterValueType<EFilterType.SITES>;
    }
  | {
      type: EFilterType.PARTNERS;
      value?: TFilterValueType<EFilterType.PARTNERS>;
    }
  | {
      type: EFilterType.RAW_MATERIALS;
      value?: TFilterValueType<EFilterType.RAW_MATERIALS>;
    }
  | {
      type: EFilterType.TIME_FRAME;
      value?: TFilterValueType<EFilterType.TIME_FRAME>;
    }
  | {
      type: EFilterType.DOCUMENT_CATEGORY;
      value?: TFilterValueType<EFilterType.DOCUMENT_CATEGORY>;
    }
  | {
      type: EFilterType.COUNTRIES;
      value?: TFilterValueType<EFilterType.COUNTRIES>;
    };

export interface IFilterComponentProps<FilterType extends TFilterType> {
  value?: TFilterValueType<FilterType> | null;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
  onChange: (value?: TFilterValueType<FilterType>) => void;

  // TODO: Move to their own separate types
  // This is a temporary prop to control whether to show previous years in the date filter.
  displayPrevYears?: boolean;
}
